// extracted by mini-css-extract-plugin
export default {"rowContainerCenter":"styles_rowContainerCenter__1nu1N","colContainerCenter":"styles_colContainerCenter__geoVd","btn":"styles_btn__8d4Cu"};